import { render } from "./RichCarousel.vue?vue&type=template&id=fbf03f92"
import script from "./RichCarousel.vue?vue&type=script&lang=js"
export * from "./RichCarousel.vue?vue&type=script&lang=js"

import "./RichCarousel.vue?vue&type=style&index=0&id=fbf03f92&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__